import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CourseService } from './course.service';
import { CourseRegistration } from './course-registration.model';

@Injectable({
    providedIn: 'root',
})
export class CourseRegistrationsService {
    isLoading:boolean = false;
    isAdd:boolean = false;
    isEditable:boolean = false;
    errorMessage:string = '';
    courseRegistrations: CourseRegistration[];

    constructor(
        private apiService: ApiService,
        private courseService: CourseService
    ) {}

    get(): void {
        this.errorMessage = '';
        this.isLoading = true;

        this.apiService.getCourseRegistrations(this.course).subscribe(
                (data) => {
                    this.courseRegistrations = data.map(courseRegistration => {return new CourseRegistration(courseRegistration);});
                    this.isLoading = false;
                },
                (error) => {
                    this.isLoading = false;
                    this.courseRegistrations = [];
                    this.errorMessage = 'An error occurred, and we were unable to load Registrations for this Course.';
                }
            );
    }

    get course() {
        return this.courseService.course;
    }

}
